module.exports = __webpack_public_path__ + "img/vol04_cup02_label03.f19310d2.png";